/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../_services/services';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Helpers} from '../../helpers';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {User} from '../../_models/user';
import Bugsnag from '@bugsnag/js';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS GROUPS                                                                                          ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public loginFG: FormGroup;
  public url = environment.oAuth.urlToken;



  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGIC FUNCTIONS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(private authService: AuthService, private formBuilder: FormBuilder, private router: Router, private toastr: ToastrService) {
  }

  private static registerUserToBugsnag(user: User): void {
    Bugsnag.setUser(user.id.toString(), user.email, user.username);
  }

  ngOnInit() {
    this.router.events.subscribe((route) => {
      if (route instanceof NavigationStart) {
        Helpers.setLoading(true);
      }

      if (route instanceof NavigationEnd) {
        Helpers.setLoading(false);
        Helpers.initPage();
      }
    });

    this.loginFG = new FormGroup({
      username: new FormControl<string>('', [
        Validators.required
      ]),
      password: new FormControl<string>('', [ Validators.required]),
    });

   /* this.loginFG = this.formBuilder.group({
      username: [null, Validators.required],
      password: [null, Validators.required]
    });*/

    this.authService.autoLogin().subscribe((res: User) => {
      if (res) {
        this.logged(res);
      }
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              LOGIN FORM CONTROLS                                                                                   ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get username(): AbstractControl {
    return this.loginFG.get('username');
  }

  get password(): AbstractControl {
    return this.loginFG.get('password');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS SUBMITS                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public loginFormSubmit() {
    if (this.loginFG.valid) {

      Helpers.setLoading(true);


      this.authService.login(this.username.value, this.password.value).subscribe((res: User) => {
        Helpers.setLoading(false);

        if (res) {
          this.logged(res);
        }
      }, (err: string) => {
        this.toastr.error(err);
        Helpers.setLoading(false);
      });
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private logged(user: User): void {
    LoginComponent.registerUserToBugsnag(user);
    this.router.navigate([this.authService.returnUrl]);
  }

}
